import React, { useState, useEffect } from "react";
import "./App.css";
import Achievements from "./Components/Achievements/Achievements";
import Campaign from "./Components/Campaign/Campaign";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Howtodonate from "./Components/HowtoDonate/Howtodonate";
import Intro from "./Components/Intro/Intro";
import JoinUs from "./Components/JoinUs/JoinUs";
import NavSocialLink from "./Components/NavSocialLink/NavSocialLink";
import Navbar from "./Components/Navbar/Navbar";
import WhoWeAre from "./Components/WhoWeAre/WhoWeAre";

function App() {
  const [isLoading, setLoading] = useState(true);

  function someRequest() {
    //Simulates a request; makes a "promise" that'll run for 2.5 seconds
    return new Promise((resolve) => setTimeout(() => resolve(), 2500));
  }

  useEffect(() => {
    someRequest().then(() => {
      const loaderElement = document.querySelector(".preloader");
      if (loaderElement) {
        loaderElement.remove();
        setLoading(!isLoading);
      }
    });
  });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <NavSocialLink />
      <Navbar></Navbar>
      <Intro />
      <WhoWeAre />
      <Campaign />
      <Howtodonate />
      <Achievements />
      <Contact />
      <JoinUs />
      <Footer />
    </>
  );
}

export default App;
